import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored document information object.
 */
export const storedDocumentInformationSchema: SchemaDefinition = {
	Name: 'stored-document-information',
	Properties: {
		LegacyId: { Type: 'number' },
		Page: { Type: 'number' },
		FileName: { Type: 'string' },
	}
}